export default __webpack_public_path__ + "components/wind-icon/static/NW@2x-ffc983f352f02999a1ef53c530385c95.png";